import { assign } from 'lodash';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import EventEmitter from '@wsb/commerce-event-emitter';
import ProductGroupConstants from '../../../constants/ProductGroupConstants';

class ProductGroupStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      fetching: false,
      error: null,
      errorRetryable: false,
      count: 0,
      totalCount: 0,
      currentPage: 0,
      perPage: 12,
      pages: 0,
      products: [],
      productDataWasLoaded: false
    };
    this.register();
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register(payload => {
      const { action } = payload;
      const { data } = action;

      switch (action.type) {
        case ProductGroupConstants.ERROR_LOADING_PRODUCT_GROUP_DATA:
          this.setState({
            fetching: false,
            productDataWasLoaded: true,
            error: action.error
          });
          break;
        case ProductGroupConstants.LOAD_PRODUCT_GROUP:
          this.setState({
            fetching: true,
            error: null,
            errorRetryable: false
          });
          break;
        case ProductGroupConstants.PRODUCT_GROUP_WAS_LOADED:
          this.setState({
            fetching: false,
            count: data.count,
            totalCount: data.total_count,
            currentPage: data.current_page,
            perPage: data.per_page,
            pages: data.pages,
            products: data.products,
            productDataWasLoaded: true
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new ProductGroupStore();
